export class CalcolaDimensioniRequestVO {
  idDocuments: string[];
  sizeLimit: number;
}
